import React, { FC } from 'react'

import { Dropdown, ICONS, Row, TextField } from '../../../components'
import { WishlistHeaderProps } from './wishlist-header.types'

import { useStyle } from './wishlist-header.styles'

export const WishlistHeader: FC<WishlistHeaderProps> = ({
  className = '',
  vendor,
  vendors,
  category,
  categories,
  searchValue,
  onChangeSearch,
  onChangeDropdown
}) => {
  const classes = useStyle()
  const isFocus = !!searchValue

  return (
    <Row fullWidth className={className}>
      <TextField
        autoFocus={isFocus}
        className={classes.search}
        defaultValue={searchValue}
        preset="border"
        leftIcon={ICONS.search}
        label="Search"
        labelTx="wishlist.filter.search"
        onChange={onChangeSearch}
      />
      <Row className={classes.input}>
        <Dropdown
          className={classes.dropdown}
          label="Category"
          labelTx="wishlist.filter.category"
          defaultValue={category}
          data={categories}
          preset="body"
          onChange={onChangeDropdown('productCategoryId')}
        />
      </Row>
      <Row className={classes.input}>
        <Dropdown
          className={classes.dropdown}
          label="Company"
          labelTx="wishlist.filter.company"
          defaultValue={vendor}
          data={vendors}
          preset="body"
          onChange={onChangeDropdown('productVendorId')}
        />
      </Row>
    </Row>
  )
}
